// extracted by mini-css-extract-plugin
export default {"information":"_261453dd","rowContainerWrapper":"_18af966f"};